import { cn } from '@/lib/utils';
import { parseHtml } from '@/utils/html-parser';

import { AssetThumbnailGrid } from './AssetThumbnailGrid';
import { SingleAssetDisplay } from './SingleAssetDisplay';
import { Asset } from '../../../types';

interface InfoCardProps {
  title: string;
  description?: string;
  assetsBaseUrl: string;
  assets: Asset[];
  onOpenViewer: (assets: Asset[], initialIndex: number) => void;
}

export const InfoCard = ({
  title,
  assets,
  onOpenViewer,
  description,
  assetsBaseUrl,
}: InfoCardProps) => {
  const hasAssets = assets.length > 0;

  return (
    <div
      className={cn(
        'w-full max-w-[280px] overflow-hidden rounded-lg border border-border bg-card shadow-blue-shadow',
        hasAssets &&
          'cursor-pointer transition-all duration-300 hover:scale-[1.02] hover:shadow-white active:scale-95'
      )}
      onClick={hasAssets ? () => onOpenViewer(assets, 0) : undefined}
    >
      {hasAssets && (
        <div className="relative aspect-[3/3] min-h-[160px] bg-livelinx-grey100 sm:min-h-[200px]">
          {assets.length === 1 ? (
            <SingleAssetDisplay asset={assets[0]} assetsBaseUrl={assetsBaseUrl} />
          ) : (
            <AssetThumbnailGrid assets={assets} assetsBaseUrl={assetsBaseUrl} />
          )}
        </div>
      )}
      <div className="p-2.5 sm:p-4">
        <h3 className="mb-1 line-clamp-2 font-body text-sm font-semibold text-livelinx-text sm:text-base">
          {parseHtml(title)}
        </h3>
        {description && (
          <p className="mb-2 font-body text-xs text-livelinx-grey200 sm:text-sm">
            {parseHtml(description)}
          </p>
        )}
        {hasAssets && (
          <button
            className="font-body text-xs text-livelinx-blue300 transition-colors hover:underline sm:text-sm"
            onClick={(e) => {
              e.stopPropagation();
              onOpenViewer(assets, 0);
            }}
          >
            See document{assets.length > 1 ? 's' : ''} ({assets.length})
          </button>
        )}
      </div>
    </div>
  );
};
